<template>
  <layout-main-inner title="新零售">
    <layout-card-wrap hasHeaderSlot
                      v-loading="loading">
      <template slot="form">
        <el-input placeholder="请输入商品名称"
                  v-model="config.productName"
                  style="width: 200px">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table border
                :data="list">
        <el-table-column label="商品名称"
                         min-width="280"
                         prop="productName">
        </el-table-column>
        <el-table-column label="商品备注"
                         min-width="240"
                         prop="productNameRemark">
        </el-table-column>
        <el-table-column label="商品类型"
                         min-width="120"
                         prop="categoryName">
        </el-table-column>
        <el-table-column label="贸易类别"
                         min-width="120">
          <template slot-scope="{row}">{{ row.tradeType | tradeType()}}</template>
        </el-table-column>
        <el-table-column label="已配置增值业务"
                         min-width="240"
                         prop="vacName">
        </el-table-column>
        <el-table-column label="操作"
                         width="60">
          <template slot-scope="{row}">
            <!-- <link-route :link-to="`/vaconfig-edit?vendorId=${row.vendorId}&productId=${row.productId}`">
              编辑
            </link-route> -->
            <el-button type="text" @click="editItem(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page.sync="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'homepage-list',
  components: {},
  props: {},
  data () {
    return {
      loading: false,
      config: { pageNum: 1, pageSize: 10, productName: '', vendorId: null },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query
    })
  },
  methods: {
    editItem (row) {
      const { vendorId, productId, productName, vacVersion } = row
      if (vacVersion === 2) {
        this.$router.push({ path: '/h5-edit-page', query: { productId, productName } })
      }
      if (vacVersion === 1) {
        this.$router.push({ path: '/vaconfig-edit', query: { vendorId, productId } })
      }
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('vas/getproductvacs', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  created () {
    if (this.query) {
      this.config = { ...this.config, ...this.query }
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
